import ColorfulSelect from './colorful-select';
export default ColorfulSelect;
